export default "__VITE_ASSET___BiVb3K$__"